import { API_BASE_URL, BACKEND_ORIGIN } from '../../config';
import { AiImageOutput } from './types';

const AI_IMAGE_ASSET_BASE_URL = BACKEND_ORIGIN || API_BASE_URL;

export function getAiImageAssetUrl(relativeUrl?: string): string | undefined {
  if (!relativeUrl) return undefined;
  return `${AI_IMAGE_ASSET_BASE_URL}${relativeUrl}`;
}

export function getAiImageOutputPreviewUrl(output: Pick<AiImageOutput, 'mediumUrl' | 'thumbnailUrl' | 'publicUrl'>): string {
  return getAiImageAssetUrl(output.mediumUrl || output.thumbnailUrl || output.publicUrl) || '';
}

export async function downloadAiImageOutput(output: Pick<AiImageOutput, 'publicUrl' | 'fileName'>): Promise<void> {
  const downloadUrl = getAiImageAssetUrl(output.publicUrl);
  if (!downloadUrl) {
    throw new Error('Kunde inte hitta någon fil att ladda ned.');
  }

  const response = await fetch(downloadUrl);
  if (!response.ok) {
    throw new Error(`Kunde inte ladda ned bilden (${response.status}).`);
  }

  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = output.fileName || 'ai-image.png';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(objectUrl);
}

export async function copyTextToClipboard(text: string): Promise<void> {
  if (!text.trim()) {
    throw new Error('Det finns ingen text att kopiera.');
  }

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  const success = document.execCommand('copy');
  document.body.removeChild(textarea);

  if (!success) {
    throw new Error('Kunde inte kopiera texten.');
  }
}
